import { render } from "./CoursePreview.vue?vue&type=template&id=c7d23ac4&scoped=true"
import script from "./CoursePreview.vue?vue&type=script&lang=js"
export * from "./CoursePreview.vue?vue&type=script&lang=js"

import "./CoursePreview.vue?vue&type=style&index=0&id=c7d23ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d23ac4"]])

export default __exports__